import React from 'react'
import ReactDOM from 'react-dom'
import CatalogExportTemplate from '@components/CatalogExportTemplate'
import { context, formatDate } from '@tools/wr-catalog-base'

const getCatalogTemplate = async (renderingContext = {}) => {
  const version = formatDate('MMMM Do, YYYY')(new Date())
  const container = document.createElement('iframe')
  const css = (await fetch('/catalog-export-template.css').then((v) => v.text())).replace(
    /\{\{assetHost\}\}/gi,
    process.env.NODE_ENV === 'development' ? 'https://ptc-v2.catalogs.dev.workrails.com' : window.location.origin,
  )

  console.log('Generating regional export document')
  console.log(
    `Items = ${
      renderingContext.items && renderingContext.items.length
    }, Region = ${context.utils.getRegionName()}, Version = ${version}`,
  )

  ReactDOM.render(
    <CatalogExportTemplate
      items={renderingContext.items}
      region={context.utils.getRegionName()}
      version={version}
      css={css}
    />,
    container,
  )
  const content = container.innerHTML

  return content
}

export default getCatalogTemplate
